import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            filter: '',
            onlyActives: true,
            onlyArchived: false,
            openAddOrder: false,
            driverToEdit: null,
            openFreeDays: false,
            changeCourierStart: false,
            courierTime: null,
            openFreeDaysObject: null,
            drivers: [],
            types: [],
            // pagination: {
            //     page: 1,
            //     limit: 100,
            //     totalCount: 0
            // }
        }
    },
    computed: {
        filteredUsers() {
            return this.drivers.filter(item => {
                if(this.onlyArchived){
                    return (item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                        item.phoneNumber.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                        item.firstName.toLowerCase().indexOf(this.filter.toLowerCase()) > -1) && item.archived;
                }else{
                    return (item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                        item.phoneNumber.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                        item.firstName.toLowerCase().indexOf(this.filter.toLowerCase()) > -1) && !item.archived;;
                }

            })
        }
    },
    methods: {
        getDrivers: getDrivers,
        checkNull: checkNull,
        openRate: openRate,
        visibleDevelop: visibleDevelop,
        deleteDriver: deleteDriver,
        archiveDriver: archiveDriver,
        editDriver: editDriver,
        allRates: allRates,
        keymonitor: keymonitor,
        clickSearch: clickSearch,
        editUser: editUser,
        deactivateDriver: deactivateDriver,
        getRate: getRate,
        round: round,
        getRateStyle: getRateStyle,
        openCourierStartTime: openCourierStartTime,
        getDriverImage: getDriverImage,
        openEditFreeDays: openEditFreeDays,
        onClickUser: onClickUser,
        openAddUserModal: openAddUserModal,
        compareActive(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareOrders(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },

    },
    created(){
        let _self = this;
        this.$topnavbar.$on('closeAddUser', () => {
            _self.openAddOrder = false;
        });
        this.$topnavbar.$on('successAddUser', () => {
            _self.openAddOrder = false;
            swal('Uspešno', 'Uspešno dodat vozač', 'success')
            _self.getDrivers();
        });

        this.$topnavbar.$on('closeAddFreeDays', () => {
            _self.openFreeDays = false;
        });
        this.$topnavbar.$on('successAddFreeDays', () => {
            _self.openFreeDays = false;
            swal('Uspešno', 'Uspešno postavljeni neradni dani.', 'success')
            _self.getDrivers();
        });

        this.$topnavbar.$on('closeCourierChangeStart', () => {
            _self.changeCourierStart = false;
        });
        this.$topnavbar.$on('successCourierChangeStart', () => {
            _self.changeCourierStart = false;
            swal('Uspešno', 'Uspešno postavljeno vreme', 'success')
            _self.getDrivers();
        });

    },
    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.getDrivers()
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
        'onlyActives': function (newVal) {
            this.getDrivers();
        },

        'onlyArchived': function (newVal) {
            this.getDrivers();
        }
    }
}

function openCourierStartTime(driver){
    this.changeCourierStart = true
    this.courierTime = driver;
}

function deactivateDriver(driver) {
    var _self = this;
    AdminApiService.deactivateDriver(driver.id, false)
        .then((response) => {
            _self.getDrivers();
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function openEditFreeDays(driver){
    this.openFreeDaysObject = driver
    this.openFreeDays = true;
}

function openAddUserModal() {
    this.driverToEdit = null
    this.openAddOrder = true;
}

function editDriver(driver) {
    this.driverToEdit = driver;
    this.openAddOrder = true;
}

function clickSearch() {
    // this.pagination.page = 1;
    // this.getDrivers()
}

function getDrivers() {
    var _self = this;
    var activeParams = this.onlyActives ? '?active=true' : '';
    AdminApiService.getDrivers(activeParams, true)
        .then((response) => {
            _self.drivers = []
            _self.drivers = response.data.map(e => {
                return {
                    id: e.id,
                    name: e.username,
                    freeDays: e.freeDays,
                    startTime: e.startTime == null ? "08:00" : e.startTime,
                    firstName: _self.checkNull(e.firstName),
                    lastName: _self.checkNull(e.lastName),
                    phoneNumber: _self.checkNull(e.phoneNumber),
                    displayStatus: e.active === true ? 'Aktivan' : 'Neaktivan',
                    active: e.active,
                    archived: e.archived,
                    averageRate: e.averageRate,
                    viberId: e.viberId,
                    profileImageUrl: e.profileImageUrl,
                }
            }).sort((a,b) => _self.compareActive(a,b));
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getDrivers();
    }
}



function onClickUser(user) {
    swal({
        title: ''+user.name + ' '+ user.surname,
        html : '<html><div class="foo">' +
            '<br><div><b>Korisničko ime:</b>&ensp;'+ user.username+'</div><br>'+
            '<div><b>Email:</b>&ensp;'+ user.email+'</div><br>'+
            '<div><b>Telefon:</b>&ensp;'+ user.phone+'</div><br>'+
            '<div><b>Preostalo treninga:</b>&ensp;'+ user.restOfTraining+'</div><br>'+

            '</div></html>',
        text: "",
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Zatvori',
        customClass: 'swal2-warning'
    }).then(function () {

    });
}

function deleteDriver(driver) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete vozača " + driver.name + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.deleteDriver(driver.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali vozača', 'success')
                _self.getDrivers();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });

}

function archiveDriver(driver, archive) {

    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da arhivirate vozača " + driver.name + "? Ukliko posle želite da povratite vozaca, morate da mu promenite lozinku.",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');

        AdminApiService.deactivateDriver(driver.id, false)
            .then((response) => {

                const newModel = {
                    firstName: driver.firstName,
                    lastName: driver.lastName,
                    phoneNumber: driver.phoneNumber,
                    username: driver.name,
                    password: "111222333"
                };
                console.log(newModel)
                AdminApiService.updateDriver(newModel, driver.id)
                    .then((response) => {
                        AdminApiService.archiveDriver(driver.id, archive)
                            .then((response) => {
                                swal('Uspešno', 'Uspešno ste arhivirali vozača', 'success')
                                _self.getDrivers();
                            })
                            .catch((error) => {
                                swal('Greška', error.data.message, 'error')
                            })
                    }).catch((error) => {
                    swal('Greška', error.data.message, 'error')
                    })

            })
            .catch((error) => {
                swal('Greška', error.data.localized_error_message, 'error')
            })


    });

}

function editUser(driver) {
    console.log(driver)
    let _self = this;

}

function checkNull(data) {
    if(data == null) return '';
    return data;
}


function getDriverImage(user){
    if(user.profileImageUrl == null) return '';
    return user.profileImageUrl + '?' + new Date().getTime();
}

function round(num){
   return Math.round((num + Number.EPSILON) * 100) / 100
}

function getRate(user){
    var courierRate = user.averageRate != null ? round(user.averageRate) : 0;
    var list = [];
    var i = 0;
    for(i = 0; i < 5; i++){
        list.push({rate: i, selected: i < courierRate})
    }
    return list;
}

function getRateStyle(rate){
    if(rate.selected){
        return "color: #fcc201;"
    }else{
        return "color: #707070;"
    }
}

function openRate(user){
    var courierRate = user.averageRate != null ? round(user.averageRate) : 1;
    this.$router.push('/courier-rate?name=' + user.firstName + '&id=' + user.id + '&rate='+ courierRate);
}


function visibleDevelop() {
    return localStorage.getItem('sb95') === 'braca'
}

function allRates(){
    this.$router.push('/courier-rates')
}


// WEBPACK FOOTER //
// ./src/components/Drivers/Drivers.js